export { InlineSearch } from './inline-search';
